import { render, staticRenderFns } from "./MyCoursesColouredTable.vue?vue&type=template&id=0b56e0a6&"
import script from "./MyCoursesColouredTable.vue?vue&type=script&lang=js&"
export * from "./MyCoursesColouredTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports